import type React from 'react';
import { useState } from 'react';
import { adminApi } from '@/admin/adminApi';
import { FitMapLogo } from '@/components/FitMapLogo';

interface Props {
  onLoggedIn: () => void;
}

export function AdminLoginPage({ onLoggedIn }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const res = await adminApi.login(password);
    setLoading(false);
    if (!res.success) {
      setError('Incorrect password.');
      return;
    }
    onLoggedIn();
  }

  return (
    <div className="mx-auto mt-24 max-w-sm px-4">
      <FitMapLogo variant="horizontal" className="mb-1" />
      <p className="mb-6 text-sm text-muted">Admin — sign in to manage brands, charts, and imports.</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="admin-password" className="block text-sm font-medium text-ink mb-2">
            Admin password
          </label>
          <input
            id="admin-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
            className="min-h-[44px] w-full rounded-xl border border-stone-200 bg-white px-3 py-2 text-base shadow-sm"
            required
          />
        </div>
        {error && (
          <p role="alert" className="text-sm text-danger">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          className="min-h-[44px] w-full rounded-xl bg-brand px-4 py-2 font-semibold text-ink shadow-card disabled:opacity-40"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
